module.exports = __webpack_public_path__ + "img/p19.b057164a.png";